import axios from 'axios';
import { functions } from 'lodash';
const API_ROOT_URL = process.env.VUE_APP_API_ROOT_URL;

var svc = {};

svc.userLogin = function (credentials) {
    return axios.post(API_ROOT_URL + 'Admins/login?include=user', credentials);
}

svc.userLogout = function (token) {
    return axios.post(API_ROOT_URL + 'Admins/logout?access_token=' + token);
}


svc.getDrivers = function (token) {
    return axios.get(API_ROOT_URL + 'drivers?filter[include]=info&access_token=' + token);
}


svc.getPassengers = function (token) {
    return axios.get(API_ROOT_URL + 'passengers?filter[include]=info&access_token=' + token);
}



svc.deleteDriver = function (token,id) {
    return axios.delete(API_ROOT_URL + 'drivers?access_token=' + token + id)
}


svc.getRides = function (token) {
    return axios.get(API_ROOT_URL +'rides?access_token=' + token)
}


svc.getBookings = function (token) {
    return axios.get(API_ROOT_URL +'rideBookings?access_token=' + token)
}


svc.getTrips = function (token) {
    return axios.get(API_ROOT_URL +'trips?access_token=' + token)
}



// svc.getSubscription = function (token) {
//     return axios.get(API_ROOT_URL +'subscriptions?access_token=' + token)
// }


// svc.getSubscriptionActive = function (token) {
//     return axios.get(API_ROOT_URL +'subscriptions?access_token=' + token)
// }


// svc.getSubscriptionExpired = function (token) {
//     return axios.get(API_ROOT_URL +'subscriptions?access_token=' + token)
// }



svc.getCars = function (token) {
    return axios.get(API_ROOT_URL + 'cars?filter[include]=driver&access_token=' + token);
}



svc.getAdresses = function (token) {
    return axios.get(API_ROOT_URL + 'places?access_token='+ token);
}


svc.getAdmins = function (token) {
    return axios.get(API_ROOT_URL + 'Admins?access_token=' + token)
}



svc.getParams = function (token) {
    return axios.get(API_ROOT_URL + 'settings?access_token=' + token)
}

svc.postLists= function(token, data) {
    axios.post(API_ROOT_URL+'lists?access_token=' + token, data)
    
}

svc.postEditeList = function(id, token, data) {

    return axios.put(
        API_ROOT_URL +'lists/' + id +'?access_token=' + token, 
        data
    );
}
    


svc.getLists = function (token) {
    return axios.get(API_ROOT_URL + 'lists?access_token=' + token)
}


svc.patchLists = function (token) {
    return axios.patch(API_ROOT_URL + 'lists?access_token=' + token)
}

svc.postApprouvDriver=function (id, value, token) {
    const filter = {
        "id" : id
    }
    const data = {
        "is_approved": value,
        "approval_datetime" : new Date().toISOString()
    }

    if (value == true)
    {
    return axios.post(API_ROOT_URL + 'drivers/'+ id +'/approve?access_token=' + token)
    } else
    {
    return axios.post(
        API_ROOT_URL + 'drivers/upsertWithWhere?where=' + JSON.stringify(filter)+'&access_token=' + token, data)
    }
}


svc.postDesaprovedDriver=function (id,token) {
    const filter = {
        "id" : id
    }
    const data = {
        "is_approved": false,
        "approval_datetime" : new Date().toISOString()
    }

    return axios.post(
        API_ROOT_URL + 'drivers/upsertWithWhere?where=' + JSON.stringify(filter) + '&access_token=' + token, data)
}



svc.getOffers = function (token) {
    return axios.get(API_ROOT_URL + 'offers?access_token=' + token)
}


export default svc;